module.exports = __webpack_public_path__ + "static/media/profilepic.275b3976.jpg";